import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import axios from "axios";
import { ReactSession } from 'react-client-session';
import autoTable from "jspdf-autotable";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import 'jspdf-autotable';


ReactSession.setStoreType("localStorage");



const Category = () => {
  const userId = ReactSession.get("welbeingId");
  const [category, setcategory] = useState([]);
  const [subcategory, setsubcategory] = useState([]);
  const [error, setError] = useState("");
  const [searchQuerys, setSearchQuerys] = useState('');
  const [filteredDatas, setFilteredDatas] = useState([]);
  const [selectedSubcat, setSelectedSubcat] = useState({});

  useEffect(() => {
    setFilteredDatas(subcategory);
  }, [subcategory]);

  const getSubcategoriesForCategory = (catId) => {
    const source = searchQuerys ? filteredDatas : subcategory;
    return source.filter((sub) => String(sub.cat_id) === String(catId));
  };

  const getVisibleCategories = () => {
    if (!searchQuerys) return category;
    const matchingCatIds = new Set(filteredDatas.map((sub) => String(sub.cat_id)));
    return category.filter((cat) => matchingCatIds.has(String(cat.cat_id)));
  };

//  useEffect(() => {
//   if (!userId || userId <= 0) {
//     navigate("/login");
//   }
// }, [userId, navigate]);


  useEffect(() => {
    const category = async () => {
      try {
        const response = await axios.get("https://projects.sninfoserv.com/welb-api/admin/categories/categories/");
        // console.log(response.data);
        if (response.data.status === "success") {

          setcategory(response.data?.data || []);
        } else {
          console.error(response.data.error?.message);
        }
      } catch (err) {
        setError(err.message);

      }
    };
    category();
  }, []);



  const subcategorys = async () => {
    try {
      const response = await axios.get("https://projects.sninfoserv.com/welb-api/admin/categories/subcategories/");
      // console.log(response.data);
      if (response.data.status === "success") {

        setsubcategory(response?.data.data);
      } else {
        console.error(response.data.error?.message);
      }
    } catch (err) {
      setError(err.message);

    }
  };

  useEffect(() => {
    subcategorys();
  }, []);




  const handleSearchInputChanges = (event) => {
    const query = event.target.value.toLowerCase().trim();
    setSearchQuerys(query);

    // Filter subcategories that match the search query
    const filteredResults = subcategory.filter((subcategory) =>
      subcategory.sub_cate.toLowerCase().includes(query)
    );

    setFilteredDatas(filteredResults);
  };



  const handleMoveSubcategory = async (subId, newCatId) => {
    if (!newCatId) return;

    setSelectedSubcat((prev) => ({
      ...prev,
      [subId]: newCatId
    }));

    try {
      const response = await axios.post(
        "https://projects.sninfoserv.com/welb-api/admin/categories/change_subcategory/",
        { sub_id: subId, new_cat_id: newCatId }
      );
      if (response.data.status === "success") {
        setSelectedSubcat((prev) => {
          const next = { ...prev };
          delete next[subId];
          return next;
        });
        await subcategorys();
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const handleVisibility = async (id, currentValue) => {
    const value = parseInt(currentValue === '0' ? '1' : '0');
    // console.log("value", value);
    const sub_id = parseInt(id);
    // console.log(id, value);

    try {
      const response = await axios.post("https://projects.sninfoserv.com/welb-api/admin/categories/subcat-visiblility/", {
        id: sub_id,
        visibility: value
      });
      // console.log(response.data);
      subcategorys();



    } catch (error) {
      console.error("Error updating preorder status:", error);
    }
  };





  // Copy
  const handleCopy = () => {
    const text = subcategory.map(subcategory =>
      `${subcategory.sub_cate}\t${subcategory.sort}`
    ).join('\n');

    navigator.clipboard.writeText(text)
      .then(() => alert('Copied to clipboard!'))
      .catch(() => alert('Copy failed!'));
  };

  // CSV
  const handleExportCSV = () => {
    const csvRows = [
      ["S.NO", "Subcategories", "Order"],
      ...subcategory.map((subcategory, index) => [index + 1, subcategory.sub_cate,
      subcategory.sort,
      ])
    ];

    const csvContent = csvRows.map(e => e.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "SubcategoriesWelbeing.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  // Pdf
  const handleExportPDF = () => {
    const doc = new jsPDF();
    doc.text("Orders Report", 14, 10);

    const tableColumn = ["S.NO", "Subcategories", "Order"];
    const tableRows = subcategory.map((subcategory, index) => [
      index + 1,
      subcategory.sub_cate,
      subcategory.sort,
    ]);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
    });

    doc.save("SubcategoriesWelbeing.pdf");
  };

  // Print

  const handlePrint = () => {
    const printContent = document.getElementById("SubcategoriesTable").outerHTML;
    const win = window.open('', '', 'height=600,width=800');
    win.document.write('<html><head><title>Print Orders</title></head><body>');
    win.document.write(printContent);
    win.document.write('</body></html>');
    win.document.close();
    win.print();
  };

  // Excel
  const handleExportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(subcategory);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Subcategories");
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), "SubcategoriesWelbeing.xlsx");
  };






  return (

    <>

      <Header />
      <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">


        <div class="body-wrapper">


          <div class="container-fluid">

            <div class="card bg-light-info shadow-none position-relative overflow-hidden">
              <div class="card-body px-4 py-3">
                <div class="row align-items-center">
                  <div class="col-9">
                    <h4 class="fw-semibold mb-8">Categories</h4>
                    <nav aria-label="breadcrumb">
                      <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a class="text-muted" href="index-2.html">Dashboard</a></li>
                        <li class="breadcrumb-item" aria-current="page">Categories</li>
                      </ol>
                    </nav>
                  </div>
                  <div class="col-3">
                    <div class="text-center mb-n5">
                      <img src="dist/images/breadcrumb/ChatBc.png" alt="" class="img-fluid mb-n4" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Content Section  */}
            <section>
              <div class="row">
                <div class="col-12">

                  <div class="card">
                    <div class="card-body">
                      <div class="mb-3">
                        <h5 class="mb-0">Add New Categories</h5>
                      </div>

                      {error && (
                        <div className="alert alert-danger alert-dismissible fade show" role="alert">
                          {error}
                          <button type="button" className="btn-close" onClick={() => setError("")}></button>
                        </div>
                      )}

                      <div class="table-responsive">
                        <div className="d-flex flex-wrap gap-2 mb-3 justify-content-between align-items-center">
                          <div className="d-flex flex-wrap gap-2">
                            <a href="/addcategory" class="btn btn-warning">Add Category</a>
                            <a href="/addsubcategory" class="btn btn-warning">Add Sub Category</a>
                          </div>
                          <div id="file_export_filter" class="dataTables_filter">
                            <label>Search:
                              <input
                                type="search"
                                placeholder="Search sub categories…"
                                value={searchQuerys}
                                onChange={handleSearchInputChanges}
                              />
                            </label>
                          </div>
                        </div>

                        <h5 className="mb-3">File Export</h5>
                        <div className="d-flex flex-wrap gap-2 mb-3">
                          <button className="btn btn-md btn-primary" onClick={handleCopy}>Copy</button>
                          <button className="btn btn-md btn-primary" onClick={handleExportCSV}>CSV</button>
                          <button className="btn btn-md btn-primary" onClick={handleExportExcel}>Excel</button>
                          <button className="btn btn-md btn-primary" onClick={handleExportPDF}>PDF</button>
                          <button className="btn btn-md btn-primary" onClick={handlePrint}>Print</button>
                        </div>

                        <table id="SubcategoriesTable" class="table border table-striped table-bordered display text-nowrap">
                          <thead class="bg-primary text-white">
                            <tr>
                              <th>#</th>
                              <th>Category / Sub Category</th>
                              <th>Order</th>
                              <th width="30%">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {getVisibleCategories().length === 0 ? (
                              <tr>
                                <td colSpan="4" className="text-center fw-bold">
                                  {searchQuerys ? "No matching sub categories found." : "No categories added yet."}
                                </td>
                              </tr>
                            ) : (
                              getVisibleCategories().map((cat) => {
                                const catSubcategories = getSubcategoriesForCategory(cat.cat_id);

                                return (
                                  <React.Fragment key={cat.cat_id}>
                                    <tr className="table-secondary">
                                      <td>{cat.cat_id}</td>
                                      <td colSpan="3">
                                        <strong>{cat.cate}</strong>
                                      </td>
                                    </tr>
                                    {catSubcategories.length === 0 ? (
                                      <tr>
                                        <td></td>
                                        <td colSpan="3" className="text-muted fst-italic">
                                          No sub categories under this category.
                                        </td>
                                      </tr>
                                    ) : (
                                      catSubcategories.map((sub, subIndex) => (
                                        <tr key={sub.sub_id}>
                                          <td>{subIndex + 1}</td>
                                          <td className="ps-4">
                                            <span className="text-muted me-2">↳</span>
                                            {sub.sub_cate}
                                          </td>
                                          <td>{sub.sort}</td>
                                          <td>
                                            <div className="d-flex flex-wrap gap-2 align-items-center">
                                              <a
                                                type="button"
                                                className={"btn btn-sm " + (sub.sub_visibility === '1' ? 'btn-success' : 'btn-danger')}
                                                onClick={() => handleVisibility(sub.sub_id, sub.sub_visibility)}
                                              >
                                                <i
                                                  style={{
                                                    color: '#fff',
                                                    fontSize: '1rem',
                                                    transition: 'all 0.3s ease',
                                                    cursor: 'pointer'
                                                  }}
                                                  className={sub.sub_visibility === '1' ? "ti ti-eye" : "ti ti-eye-off"}
                                                />
                                              </a>
                                              <select
                                                className="form-control form-control-sm"
                                                style={{ maxWidth: '220px' }}
                                                value={selectedSubcat[sub.sub_id] || ''}
                                                onChange={(e) => handleMoveSubcategory(sub.sub_id, e.target.value)}
                                              >
                                                <option value="">Move to category…</option>
                                                {category
                                                  .filter((c) => String(c.cat_id) !== String(sub.cat_id))
                                                  .map((c) => (
                                                    <option key={c.cat_id} value={c.cat_id}>
                                                      {c.cate}
                                                    </option>
                                                  ))}
                                              </select>
                                            </div>
                                          </td>
                                        </tr>
                                      ))
                                    )}
                                  </React.Fragment>
                                );
                              })
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  )
}
export default Category;